export const productImageUrlPrefix = "https://rohobot-api.yisehakm.com/product/";
export const userImageUrlPrefix = "https://rohobot-api.yisehakm.com/user/";
// export const productImageUrlPrefix = "http://localhost:3001/product/";
// export const userImageUrlPrefix = "http://localhost:3001/user/";

// Route paths
export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/sign-up",
  EDIT_PROFILE: "/edit",
  MY_STORE: "/my-store",
  SELL: "/Sell",
  SEARCH: "/search",
  CART: "/cart",
  EDIT_PRODUCT: "/editProduct",
  MY_PRODUCT_DETAIL: "/myProductDetail",
  CART_PRODUCT_DETAIL: "/cartProductDetail",
  PRODUCT_DETAIL: "/productDetail"
};

export const validationColors = {
  bgValid: "bg-input-valid",
  bgWait: "bg-input-wait",
  bgInvalid: "border-red-500",
  Valid: "bg-input-valid border-input-valid",
  Wait: "bg-input-wait border-input-wait",
  Invalid: "bg-input-invalid border-input-invalid",
};

export const productCondition = [
  "New",
  "Like New",
  "Used",
  "Refurbished",
  "For Parts",
  "Damaged",
];

export const productCategory = [
  "Computers", "Laptops", "Tablets", "Smartphones", "Televisions", "Cameras", "Headphones", "Headsets", "Speakers", "Wearables", "Drones", "Smart Home Devices",
  
  "Refrigerators", "Washing Machines", "Microwaves", "Vacuum Cleaners", "Air Conditioners", "Heaters", "Dishwashers", "Coffee Makers", "Blenders", "Toasters",
  // Furniture
  "Sofas", "Beds", "Dining Tables", "Chairs", "Desks", "Wardrobes", "Coffee Tables", "Bookcases", "Cabinets", 
  // Fashion
  "Men's Clothing", "Women's Clothing", "Kids' Clothing", "Shoes", "Handbags", "Accessories", "Jewelry", "Sunglasses", "Watches", 
  // Beauty & Personal Care
  "Skincare", "Haircare", "Makeup", "Fragrances", "Bath & Body", "Oral Care", "Men's Grooming",
  // Health & Wellness
  "Vitamins & Supplements", "Fitness Equipment", "Medical Supplies", "Personal Care Appliances", "First Aid",
  // Sports & Outdoors
  "Sports Equipment", "Outdoor Gear", "Camping Equipment", "Bicycles", "Fishing Gear", "Fitness Apparel", 
  // Automotive
  "Vehicles", "Cars", "Buses & Microbuses", "Heavy Equipment", "Trucks & Trailers", "Motorcycles & Scooters", "Watercraft & Boats", "Vehicles Parts & Accessories", "Tires",
  // Toys & Games
  "Action Figures", "Dolls", "Educational Toys", "Board Games", "Puzzles", "Video Games", 
  // Books
  "Fiction", "Non-Fiction", "Children's Books", "Textbooks", "Comics & Graphic Novels", "eBooks", 
  // Music & Movies
  "CDs", "Vinyl Records", "DVDs", "Blu-rays", "Musical Instruments",
  // Groceries
  "Fresh Produce", "Dairy Products", "Snacks", "Beverages", "Baked Goods", "Frozen Foods",
  // Pet Supplies
  "Pet Food", "Pet Toys", "Pet Accessories", "Pet Health",
  // Office Supplies
  "Printers", "Office Furniture", "Stationery", "Office Electronics", "Ink & Toner",
  // Garden & Outdoor
  "Garden Tools", "Outdoor Furniture", "Barbecues", "Plants & Seeds", "Outdoor Lighting",
  // Home Decor
  "Wall Art", "Rugs", "Curtains", "Bedding", "Mirrors", "Clocks",
  // Baby Products
  "Baby Clothing", "Strollers", "Car Seats", "Nursery Furniture", "Baby Toys",
  // Crafts & Sewing
  "Sewing Machines", "Art Supplies", "Craft Kits", "Fabrics", "Knitting & Crochet",  
  // Industrial & Scientific
  "Lab Equipment", "Industrial Tools", "Safety Gear", "Measurement Instruments",
  // Travel & Luggage
  "Suitcases", "Travel Accessories", "Backpacks", "Travel Organizers"
];

  export const productBrand = [
    "Apple", "Samsung", "Sony", "Microsoft", "LG", "HP", "Toyota", "Mercedes", "BMW", 
    "Honda", "Ford", "Nissan", "Adidas", "Nike", "Puma", "Coca-Cola", "Pepsi", "Intel", 
    "AMD", "Lenovo", "Dell", "Asus", "Acer", "Panasonic", "Philips", "Toshiba", "Canon", 
    "Nikon", "Olympus", "Fujifilm", "Leica", "Rolex", "Omega", "Swatch", "Ray-Ban", 
    "Oakley", "Burberry", "Chanel", "Dior", "Gucci", "Prada", "Louis Vuitton", "Hermès", 
    "Versace", "Ralph Lauren", "Tommy Hilfiger", "Calvin Klein", "Giorgio Armani", 
    "Dolce & Gabbana", "Zara", "H&M", "Uniqlo", "Levi's", "Wrangler", "The North Face", 
    "Columbia", "Patagonia", "Under Armour", "Reebok", "New Balance", "Vans", "Converse", 
    "Polo Ralph Lauren", "Lacoste", "Guess", "Diesel", "Abercrombie & Fitch", 
    "American Eagle", "Hollister", "Bath & Body Works", "L'Oréal", "Estée Lauder", 
    "Clinique", "Maybelline", "Dove", "Nivea", "Gillette", "Oral-B", "Colgate", 
    "Listerine", "Johnson & Johnson", "Procter & Gamble", "Unilever", "Nestlé", 
    "Kellogg's", "General Mills", "Mars", "Hershey", "Mondelez", "PepsiCo", "Frito-Lay", 
    "Quaker", "Lipton", "Ben & Jerry's", "Haagen-Dazs", "Starbucks", "McDonald's", 
    "Burger King", "KFC", "Pizza Hut", "Subway", "Taco Bell", "Domino's", "Dunkin' Donuts", 
    "7-Eleven", "Walmart", "Target", "Costco", "IKEA", "Best Buy", "Home Depot", 
    "Lowe's", "Walgreens", "CVS", "Rite Aid", "Kroger", "Safeway", "Publix", "Aldi", 
    "Lidl", "Whole Foods", "Trader Joe's", "Albertsons", "Macy's", "Saks Fifth Avenue", 
    "Nordstrom", "Neiman Marcus", "Bloomingdale's", "JCPenney", "Kohl's", "Sears", 
    "Dillard's", "Men's Wearhouse", "Jos. A. Bank", "Banana Republic", "Gap", "Old Navy", 
    "Athleta", "Forever 21", "Urban Outfitters", "Free People", "Anthropologie", "Torrid", 
    "Hot Topic", "Charlotte Russe", "Express", "Ann Taylor", "LOFT", "Lane Bryant", 
    "T.J. Maxx", "Marshalls", "Ross", "Burlington", "Nordstrom Rack", "Saks OFF 5TH", 
    "Neiman Marcus Last Call", "Boscov's", "Von Maur", "Belk", "Stage Stores", "Bealls", 
    "Bon-Ton", "Michaels", "Hobby Lobby", "Joann", "A.C. Moore", "Staples", "Office Depot", 
    "OfficeMax", "FedEx Office", "UPS Store", "Sherwin-Williams", "Benjamin Moore", 
    "Dunn-Edwards", "Behr", "Valspar", "PPG", "Glidden", "Dutch Boy", "Kelly-Moore", 
    "Olympic", "Pratt & Lambert", "Pittsburgh Paints", "Tiffany & Co.", "Cartier", 
    "Bulgari", "Van Cleef & Arpels", "Chopard", "Harry Winston", "Graff", "David Yurman", 
    "Boucheron", "Piaget", "Tissot", "TAG Heuer", "Breitling", "IWC", "Patek Philippe", 
    "Jaeger-LeCoultre", "Vacheron Constantin", "Audemars Piguet", "Hublot", "Franck Muller", 
    "Girard-Perregaux", "Longines", "Baume & Mercier", "Movado", "Raymond Weil", "Seiko", 
    "Timex", "Fossil", "Michael Kors", "Bulova", "Invicta", "Emporio Armani", "Hugo Boss", 
    "DKNY", "Skagen", "Armani Exchange", "Nautica", "Anne Klein", "Kate Spade", 
    "Marc Jacobs", "Tory Burch", "Fendi", "Bvlgari", "Valentino", "Givenchy", 
    "Alexander McQueen", "Balenciaga", "Balmain", "Celine", "Chloé", "Christian Louboutin", 
    "Coach", "Furla", "Jimmy Choo", "Kenzo", "Lanvin", "Longchamp", "Miu Miu", 
    "Saint Laurent", "Salvatore Ferragamo", "Stella McCartney", "Tod's", "Tom Ford", 
    "Victoria's Secret", "Yves Saint Laurent", "Zegna", "Berluti", "Brioni", "Canali", 
    "Corneliani", "Ermenegildo Zegna", "Hickey Freeman", "Isaia", "Kiton", "Loro Piana", 
    "Trussardi", "Z Zegna", "Zenith", "Tag Heuer", "Tudor", "Richard Mille", "Panerai", 
    "Breguet", "Blancpain", "F.P. Journe", "Arnold & Son", "Bovet", "Chronoswiss", 
    "Corum", "Eberhard & Co.", "Glashütte Original", "Graham", "Hautlence", "HYT", 
    "Jacob & Co.", "Jaquet Droz", "Laurent Ferrier", "Linde Werdelin", "Louis Moinet", 
    "MB&F", "Maurice Lacroix", "Moser & Cie.", "Perrelet", "Roger Dubuis", "Romain Jerome", 
    "Vulcain", "Casio", "Orient", "Hamilton", "Armitron", "Nixon", "Armani", "Michele", 
    "Citizen", "Parmigiani Fleurier", "Urwerk", "Ulysse Nardin", "Audi", "Volkswagen", 
    "Chevrolet", "GMC", "Jeep", "Subaru", "Mazda", "Hyundai", "Kia", "Buick", "Cadillac", 
    "Chrysler", "Dodge", "Fiat", "Ram", "Acura", "Alfa Romeo", "Aston Martin", "Bentley", 
    "Bugatti", "Ferrari", "Genesis", "Infiniti", "Jaguar", "Land Rover", "Lamborghini", 
    "Lotus", "Maserati", "McLaren", "Mini", "Mitsubishi", "Pagani", "Porsche", 
    "Rolls-Royce", "Saab", "Scion", "Suzuki", "Tesla", "Volvo", "Peugeot", "Renault", 
    "Citroën", "Skoda", "SEAT", "Opel", "Vauxhall", "Holden", "Lincoln", "Rivian", 
    "Lucid", "Polestar", "MG", "Dacia", "Lancia", "Koenigsegg", "Spyker", "SSC North America", 
    "Noble", "Fisker", "BYD", "Geely", "Great Wall", "Haval", "Changan", "Roewe", "NIO", 
    "XPeng", "Li Auto", "Wuling", "Hongqi", "Zotye", "Chery", "Dongfeng", "Lifan", 
    "Baojun", "GAC", "FAW", "SAIC Motor", "BAIC", "Brilliance Auto", "JAC Motors", 
    "Venucia", "Zhongxing", "Borgward", "Qoros", "Luxgen", "Tata", "Mahindra", "Proton", 
    "Perodua", "Maruti Suzuki", "Isuzu", "Hino", "Daewoo", "SsangYong", "Foton", "VinFast", 
    "Swarovski", "Mango", "Bershka", "Stradivarius", "Topshop", "Primark", "TJ Maxx", 
    "Anbessa", "Pilot", "Uni-Ball", "Sharpie", "Crayola", "BIC", "Faber-Castell", 
    "Prismacolor", "Moleskine", "Zebra", "3M", "Pentel", "Staedtler", "Bic", "Parker", 
    "Waterman", "Montblanc", "Rotring", "Sakura", "EXPO", "Tombow", "Kokuyo", "MUJI", 
    "Leuchtturm1917", "Rhodia", "Hilroy", "Mead", "Ampad", "Norcom"
];

export const cities = [
  "Adama", "Addis Ababa", "Arba Minch", "Assela", "Asella", "Axum", "Bahir Dar", "Bishoftu", "Bonga", "Debre Birhan", "Debre Markos", "Debre Tabor", "Dessie", "Dilla", "Dire Dawa", "Gambela", "Gondar", "Harar", "Hargeisa", "Hawassa", "Hosana", "Jijiga", "Jimma", "Mekele", "Nekemte", "Semera", "Sebeta", "Shashamane", "Shire", "Sodo"
]